module.exports = {"331123001":"妙高街道","331123002":"云峰街道","331123102":"新路湾镇","331123103":"北界镇","331123104":"金竹镇","331123105":"大柘镇","331123106":"石练镇","331123107":"王村口镇","331123108":"黄沙腰镇","331123200":"三仁畲族乡","331123201":"濂竹乡","331123202":"应村乡","331123203":"高坪乡","331123204":"湖山乡","331123205":"蔡源乡","331123206":"焦滩乡","331123207":"龙洋乡","331123208":"柘岱口乡","331123209":"西畈乡","331123210":"垵口乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/331123.json
// module id = 1029
// module chunks = 0